<!-- prettier-ignore -->
<!-- #region customCode: page-component-html__header__start -->

<!-- #endregion customCode: page-component-html__header__start -->

<!-- Container: Main Container -->
<div class="rappider-container main-container col-12">
  <div class="heading-1">
    <div class="heading-left">
      <!-- Component: Heading 1 -->
      <img src="/assets/liife-logo-white.png"
           style="width: 60px; max-width: 100%; margin-right:10px;" />
      <h4>Liife Core Tenant Admin</h4>
    </div>

    <!-- <rappider-heading [content]="heading_1.content"
                      [type]="heading_1.type">
    </rappider-heading> -->
    <div class="heading-right">
      <button nz-button
              class="logout-button"
              (click)="onLogout()">
        <i class="fa-solid fa-right-from-bracket"></i>
        <span>Logout</span>
      </button>
    </div>


  </div>

  <!-- Container: Container 2 -->
  <div class="rappider-container container-2 col-12">
    <!-- Container: Container 3 -->
    <!-- <div class="rappider-container container-3 col-3">
      <div class="rappider-component menu-2">
        <rappider-menu
          [config]="menu_2.config"
          [isCollapsed]="menu_2.isCollapsed"
          [paddingValue]="menu_2.paddingValue"
          [menuPlacement]="menu_2.menuPlacement"
          [isDisabled]="menu_2.isDisabled"
          [showLabels]="menu_2.showLabels"
          [activeItem]="menu_2.activeItem"
          [currentSubmenuOnly]="menu_2.currentSubmenuOnly"
        >
        </rappider-menu>
      </div>
    </div> -->

    <!-- Container: Container 4 -->
    <div class="rappider-container container-4 col-12">
      <div>
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>

<!-- prettier-ignore -->
<!-- #region customCode: page-component-html__footer__end -->

<!-- #endregion customCode: page-component-html__footer__end -->